import { useState, useEffect, useRef } from "react";
import styles from "./shareWidget.module.css";

/* project social badge icons */
import igIcon from "../../images/social-icons/instagram.png";
import fbIcon from "../../images/social-icons/facebook.png";
import liIcon from "../../images/social-icons/linkedin.png";
import ytIcon from "../../images/social-icons/youtube.png";
import xIcon from "../../images/social-icons/x.png";
import ptIcon from "../../images/social-icons/pintrest.png";
import thIcon from "../../images/icons/threads.webp";
import mdIcon from "../../images/icons/medium.webp";
import waIcon from "../../images/icons/whatsapp.webp";

/* Floating "share" speed-dial. A single JJF-green FAB that, when clicked,
   fans a stack of the project's own social badge icons upward. Self-contained
   (its own CSS module) so it can be dropped anywhere — inside the .jjfv2 pages
   or globally in App. Closes on outside-click or Escape. */

const LINKS = [
  { name: "Instagram", href: "https://www.instagram.com/TeamJJFIndia/", img: igIcon },
  { name: "LinkedIn", href: "https://www.linkedin.com/company/TeamJJFIndia/", img: liIcon },
  { name: "Facebook", href: "https://www.facebook.com/TeamJJFIndia/", img: fbIcon },
  { name: "YouTube", href: "https://www.youtube.com/@TeamJJFIndia/", img: ytIcon },
  { name: "X", href: "https://x.com/TeamJJFIndia/", img: xIcon },
  { name: "Threads", href: "https://www.threads.net/@TeamJJFIndia/", img: thIcon },
  { name: "Pinterest", href: "https://in.pinterest.com/TeamJJFIndia/", img: ptIcon },
  { name: "Medium", href: "https://medium.com/@TeamJJFIndia", img: mdIcon },
  { name: "WhatsApp", href: "https://wa.me/919552895289", img: waIcon },
];

export default function ShareWidget() {
  const [open, setOpen] = useState(false);
  const ref = useRef(null);

  useEffect(() => {
    if (!open) return undefined;
    // Announce the open state so the page can move other bottom-right FABs
    // (e.g. the homepage back-to-top button) out of the expanding menu's way.
    document.body.classList.add("jjf-share-open");
    const onDoc = (e) => {
      if (ref.current && !ref.current.contains(e.target)) setOpen(false);
    };
    const onKey = (e) => {
      if (e.key === "Escape") setOpen(false);
    };
    document.addEventListener("mousedown", onDoc);
    document.addEventListener("keydown", onKey);
    return () => {
      document.body.classList.remove("jjf-share-open");
      document.removeEventListener("mousedown", onDoc);
      document.removeEventListener("keydown", onKey);
    };
  }, [open]);

  return (
    <div className={styles.share + (open ? " " + styles.open : "")} ref={ref}>
      <ul className={styles.list}>
        {LINKS.map((l, i) => (
          <li key={l.name} style={{ transitionDelay: (open ? i * 45 : (LINKS.length - 1 - i) * 30) + "ms" }}>
            <a
              className={styles.soc}
              href={l.href}
              target="_blank"
              rel="noopener noreferrer"
              aria-label={`Visit us on ${l.name}`}
              title={l.name}
              tabIndex={open ? 0 : -1}
              onClick={() => setOpen(false)}
            >
              <img src={l.img} alt={l.name} loading="lazy" />
            </a>
          </li>
        ))}
      </ul>

      <button
        type="button"
        className={styles.fab}
        aria-label={open ? "Close share menu" : "Share JJF India"}
        aria-expanded={open}
        onClick={() => setOpen((o) => !o)}
      >
        <svg className={styles.iconShare} viewBox="0 0 24 24" fill="none" aria-hidden="true">
          <circle cx="18" cy="5" r="3" fill="currentColor" />
          <circle cx="6" cy="12" r="3" fill="currentColor" />
          <circle cx="18" cy="19" r="3" fill="currentColor" />
          <path d="M8.6 10.6l6.8-4.1M8.6 13.4l6.8 4.1" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
        </svg>
        <svg className={styles.iconClose} viewBox="0 0 24 24" fill="none" aria-hidden="true">
          <path d="M6 6l12 12M18 6L6 18" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" />
        </svg>
      </button>
    </div>
  );
}
